import "../../../styles/input.scss";

import React, {Component} from "react";

import PropTypes from "prop-types";
import Scroll from "./Scroll";

export class TabList extends Component {
    constructor(props){
        super(props);

        this.setSelement = this.setSelement.bind(this);
    }

    setSelement(element) {
        this.element = element;
    }

    render() {
        const {
            tabIndexSelected,
            roundCorner,
            onTabClick
        } = this.props;
        const tabChildrenWithProps = [];
        const otherChildren = [];

        React.Children.forEach(this.props.children, function(child, index) {
            if( child ) {
                if(child.type === Tab) {
                    tabChildrenWithProps.push( React.cloneElement(child, {
                        tabSelected: tabIndexSelected===index,
                        index: index,
                        onTabClick: onTabClick,
                        key: index
                    }) );
                } else {
                    otherChildren.push( React.cloneElement(child, {
                        key: index
                    }) );
                }
            }
        });
        return(
            <div className="tabs-tab-wrapper">
                <Scroll className={`tabs-tab-list ${roundCorner?"round-corner":""}`} shadowY={false} shadowStyle={{borderTopLeftRadius:"8px"}}>
                    {tabChildrenWithProps}
                </Scroll>
                {otherChildren}
            </div>
        );
    }
}
TabList.propTypes = {
    children: PropTypes.node.isRequired,
    tabIndexSelected: PropTypes.number,
    // Private: Tabs will use this
    onTabClick: PropTypes.func,
    roundCorner: PropTypes.bool,
};


export class Tab extends Component {
    constructor(props){
        super(props);

        this.onTabClick = this.onTabClick.bind(this);
    }

    onTabClick(e) {
        const {
            onTabClick,
            onClick,
            index
        } = this.props;
        if( onTabClick ){
            onTabClick(e, index);
        }
        if( onClick ){
            onClick(index);
        }
    }

    render() {
        const {
            tabSelected,
            label,
            small,
        } = this.props;
        return(
            <div className={`tab-item ${tabSelected && "active"}`} onClick={this.onTabClick}>
                <div className={`tab-item-content ${small && "tab-item-content-small"}`}>
                    {label}
                </div>
            </div>
        );
    }
}
Tab.propTypes = {
    tabSelected: PropTypes.bool,
    small: PropTypes.bool,
    label: PropTypes.string.isRequired,
    // Private: TabList will use this
    onTabClick: PropTypes.func,
    // Use this if  you want a callback when tab is clicked
    onClick: PropTypes.func,
    index: PropTypes.number,
    id: PropTypes.string,
};
Tab.defaultProps = {
    tabSelected: false
};

export class TabPanel extends Component {
    render() {
        const {
            children,
            overflowHidden,
            onScroll
        } = this.props;

        return (
            <div className="tabs-tab-panel" style={{position:"relative", overflow: overflowHidden ? "hidden" : undefined}} onScroll={onScroll}>
                {children}
            </div>
        );
    }
}
TabPanel.propTypes = {
    children: PropTypes.node.isRequired,
    onScroll: PropTypes.func,
    overflowHidden: PropTypes.bool
};

export class Tabs extends Component {
    constructor(props){
        super(props);

        let selectIndex = 0;
        let count = 0;
        if( props.startTabId ) {
            React.Children.forEach(props.children, child => {
                if( child.type === TabList ){
                    for(let i=0; i<child.props.children.length; i++){
                        if( child.props.children[i].props && child.props.children[i].props.id === props.startTabId ) {
                            selectIndex = count;
                        }
                        count += child.props.children[i].type === Tab ? 1 : 0;
                    }
                }
            });
        }
        this.state = {
            tabIndexSelected: selectIndex,
        };

        this.onTabClick = this.onTabClick.bind(this);
    }

    onTabClick(e, index) {
        e.stopPropagation();

        this.setState({
            tabIndexSelected: index
        });

        if (this.props.onTabSelected) {
            this.props.onTabSelected(index);
        }
    }
    

    render() {

        const {
            selectIndex,
        } = this.props;

        const checkIndex = selectIndex >=0 ? selectIndex : this.state.tabIndexSelected;

        const childrenWithProps = [];
        let count = 0;
        let foundPanel = false;
        let lastPanel = null;
        //prepare the children with needed props
        React.Children.forEach(this.props.children, child => {
            //if the child is a TabList button on the otop
            if( child.type === TabList ){
                childrenWithProps.push( React.cloneElement(child, {
                    tabIndexSelected: checkIndex,
                    onTabClick: this.onTabClick,
                    key: -1
                }) );
            }
            //if it is a panel with all the content
            else {
                if( this.state.tabIndexSelected===count ){
                    foundPanel = true;
                    childrenWithProps.push( React.cloneElement(child, {
                        key: count
                    }) );
                } else {
                    lastPanel = React.cloneElement(child, {
                        key: count
                    });
                }
                count++;
            }
        });
        if( foundPanel==false && lastPanel!=null ){
            childrenWithProps.push( lastPanel );
        }
        return(
            <div className={"tabs-wrapper"}>
                {childrenWithProps}
            </div>
        );
    }
}

Tabs.propTypes = {
    children: PropTypes.node.isRequired,
    startTabId: PropTypes.string,
    onTabSelected: PropTypes.func,
    selectIndex: PropTypes.number,
};

Tabs.defaultProps = {
};